import React, { useState, useEffect } from "react";
import { Link, useNavigate } from "react-router-dom";
import { FaRegEye } from "react-icons/fa";
import { IoEyeOffOutline } from "react-icons/io5";
import axios from "axios";
import ReCaptcha from "../../components/Recaptcha/Recaptcha";
import Loader from "../../containers/Loader/Loader";
import { verifyLogin, clearVerifyCache } from "../../services/authService";
import "./Login.css";

axios.defaults.withCredentials = true;
const svg =
  "https://accet-site-media-trial.s3.ap-northeast-1.amazonaws.com/Login-Logout/login_svg.webp";

const Login = () => {
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [usrerror, setUsrerror] = useState("");
  const [pswderror, setPswderror] = useState("");
  const [show, setShow] = useState(false);
  const [retoken, setreToken] = useState("");
  const [submitEnabled, setSubmitEnabled] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    if ( username.length && password.length) setSubmitEnabled(true);
  }, [retoken, username, password]);


  useEffect(() => {
    let mounted = true;
    setLoading(true);
    console.log("verifying login statusssss.....");
    console.log("Deployment check...... 2");
    const checkLogin = async () => {
      try {
        const verifyRes = await verifyLogin();
        if (!mounted) return;

        if (verifyRes.data.token_status === "okay") {
          // Part-time / full-time students have dedicated result pages
          console.log(verifyRes.data.isPartTime);
          if (verifyRes.data.isPartTime) {
            if (verifyRes.data.pt_ft_type === "pt_stud") {
              navigate("/results_pt_ft", { replace: true });
            } else if (verifyRes.data.pt_ft_type === "me_stud") {
              navigate("/results_me", { replace: true });
            }
          } else {
            // Non-part-time users: route based on access level
            if (verifyRes.data.access === "student") {
              navigate("/dashboard", { replace: true });
            } else if (verifyRes.data.access === "admin") {
              navigate("/admin-panel", { replace: true });
            } else if (verifyRes.data.access === "feedbackadmin") {
              navigate("/FeedbackPdf", { replace: true });
            }
          }
        }
      } catch (err) {
        console.error("Verification error:", err);
      } finally {
        if (mounted) setLoading(false);
      }
    };

    checkLogin();

    return () => {
      mounted = false;
    };
  }, []);

  const togglePassword = () => {
    setShow(!show);
  };

  const handleToken = (token) => {
    setreToken(token);
  };
  //FOR PT FT PASSWORD HANDLING
  function changePasswordType(password) {
    // Expecting "DDMMYYYY" = 8 digits
    if (!/^\d{8}$/.test(password)) {
      return "Invalid";
    }

    const day = password.substring(0, 2);
    const month = password.substring(2, 4);
    const year = password.substring(4, 8);

    const months = [
      "Jan",
      "Feb",
      "Mar",
      "Apr",
      "May",
      "Jun",
      "Jul",
      "Aug",
      "Sep",
      "Oct",
      "Nov",
      "Dec",
    ];

    const monthIndex = parseInt(month, 10) - 1;

    // If month is not valid
    if (monthIndex < 0 || monthIndex > 11) {
      return "Invalid";
    }

    return `${day} ${months[monthIndex]} ${year}`;
  }

  const isptoft = (regno) => {
    if (
      regno.length == 11 &&
      (regno.substring(6, 7) == "3" || regno.substring(6, 7) == "2")
    ) {
      return { isPtFt: true, finalRegno: regno };
    } else if (regno === "1933506" || regno === "2034002") {
      return { isPtFt: true, finalRegno: "9176" + regno };
    }

    return { isPtFt: false, finalRegno: regno };
  };
  const is_first_year = (regno) => {

    const pattern = /^917625(11|12|13|14|15|16)[01][0-9]{2}$/;
    const isValid_first_year = pattern.test(regno);

    return {
      regno: isValid_first_year ? regno : null,
      isValid_first_year: isValid_first_year,
    };
  };

  const is_second_year = (regno) => {
    const pattern = /^917624\d{5}$/;
    const isValid_second_year = pattern.test(regno);

    return {
      regno: isValid_second_year ? regno : null,
      isValid_second_year: isValid_second_year,
    };
  };

  const is_third_year = (regno) => {
    const pattern = /^917623\d{5}$/;
    const isValid_third_year = pattern.test(regno);

    return {
      regno: isValid_third_year ? regno : null,
      isValid_third_year: isValid_third_year,
    };
  };

  const is_fourth_year = (regno) => {
    const pattern = /^917622\d{5}$/;
    const isValid_fourth_year = pattern.test(regno);

    return {
      regno: isValid_fourth_year ? regno : null,
      isValid_fourth_year: isValid_fourth_year,
    };
  };

  const form_submit = async (e) => {
    e.preventDefault();
    // setUsername(username.trim());
    const trimmedUsername = username.trim();
    // console.log("Trimmed Username:", trimmedUsername);
    setPassword(password.trim());

    let valid = true;

    if (!/^\d{7}$/.test(trimmedUsername) && !/^\d{11}$/.test(trimmedUsername)) {
      setUsrerror("Enter valid register number");
      valid = false;
    } else {
      setUsrerror("");
    }

    if (password.length === 0) {
      setPswderror("Enter Password");
      valid = false;
    } else {
      setPswderror("");
    }

    if (!valid) return;
    // if (is_first_year(trimmedUsername).isValid_first_year) {
    //   alert("First Year students results have not been released yet");
    //   return;
    // }
    //  if (is_second_year(trimmedUsername).isValid_second_year) {
    //   alert("Second Year students results have not been released yet");
    //   return;
    // }
    //  if (is_third_year(trimmedUsername).isValid_third_year) {
    //   alert("Third Year students results have not been released yet");
    //   return;
    // }
    //  if (is_fourth_year(trimmedUsername).isValid_fourth_year) {
    //   alert("Fourth Year students results have not been released yet");
    //   return;
    // }




    try {
      let finalPassword = password;
      setSubmitEnabled(false);
      setLoading(true);
      // The login request is sent to the backend with the username, password, and reCAPTCHA token.
      // The response is then processed to determine the next steps based on the user's credentials and status.

      //FOR PT FT PASSWORD HANDLING
      const { isPtFt, finalRegno } = isptoft(trimmedUsername);
      // const { regno, isValid_first_year } = is_first_year(trimmedUsername);
      // console.log("isPtFt:", isPtFt, "finalRegno:", finalRegno);
      if (isPtFt) {
        let tempPassword = changePasswordType(password);
        if (tempPassword === "Invalid") {
          console.log("Invalid format");
          setPswderror("Incorrect password Type");
          setreToken("");
          setSubmitEnabled(true);
          setLoading(false);
          return;
        }
        finalPassword = tempPassword;
        // console.log("Converted Password:", finalPassword)
      }
      // if (isValid_first_year) {
      //   let tempPassword = changePasswordType(password);
      //   if (tempPassword === "Invalid") {
      //     console.log("Invalid format")
      //     setPswderror("Incorrect password Type");
      //     setreToken("");
      //     setSubmitEnabled(true);
      //     setLoading(false);
      //     return;
      //   }
      //   finalPassword = tempPassword;
      //   console.log("Converted Password for first year:", finalPassword)
      // }
      // console.log("Final Regno:", finalRegno, "Final Password:", finalPassword);
      const res = await axios.post("/backend/login", {
        username: finalRegno,
        password: finalPassword,
        retoken,
      });
      // console.log("Prininting from login jsx", res.data);
      if (res.data.username_not_found) {
        setUsrerror("Register number not found");
      } else if (res.data.pswd_status) {
        // Successful password — clear cached verification and route immediately
        clearVerifyCache();

        // Admin / feedbackadmin go to their panels
        if (res.data.access === "admin") {
          navigate("/admin-panel", {
            replace: true,
            state: { pflag: res.data.p_flag, regno: res.data.regno },
          });
        } else if (res.data.access === "feedbackadmin") {
          navigate("/FeedbackPdf", {
            replace: true,
            state: { pflag: res.data.p_flag, regno: res.data.regno },
          });
        } else if (res.data.isPartTime) {
          // Part-time students: route to correct results page immediately
          if (res.data.pt_ft_type === "pt_stud") {
            navigate("/results_pt_ft", {
              replace: true,
              state: {
                pflag: res.data.p_flag,
                regno: res.data.regno,
                pt_ft_type: res.data.pt_ft_type,
              },
            });
            console.log("Navigating to PT results page");
          } else if (res.data.pt_ft_type === "me_stud") {
            navigate("/results_me", {
              replace: true,
              state: {
                pflag: res.data.p_flag,
                regno: res.data.regno,
                pt_ft_type: res.data.pt_ft_type,
              },
            });
            console.log("Navigating to ME results page");
          } else {
            // Unknown pt/ft type fallback
            navigate("/dashboard", {
              replace: true,
              state: { pflag: res.data.p_flag, regno: res.data.regno },
            });
          }
        } else {
          // Regular full-time student
          navigate("/dashboard", {
            replace: true,
            state: { pflag: res.data.p_flag, regno: res.data.regno },
          });
        }
      } else {
        setPassword("");
        setPswderror("Incorrect password");
        setShowModal(true);
        setreToken("");
      }
    } catch (error) {
      console.error("Login error:", error);
    } finally {
      setSubmitEnabled(true);
      setLoading(false);
    }
  };

  return (
    <div className="login-pagef">
      {loading && <Loader />}
      <div className="login-page">
        <section className="login-side">
          <img src={svg} alt="" />
        </section>

        <section className="login-main">
          <div className="login-container">
            <p className="login-title">Welcome</p>
            <div className="login-separator"></div>
            <p className="login-welcome-message">
              Please, provide the valid login credentials to sign in
            </p>

            <form className="login-form" onSubmit={form_submit}>
              {usrerror && <div className="login_err_msg">{usrerror}</div>}
              <div className="form-control">
                <input
                  className="login-input"
                  autoComplete="username"
                  value={username}
                  type="text"
                  placeholder="Register Number"
                  onChange={(e) => setUsername(e.target.value)}
                />
                <i className="fa fa-user"></i>
              </div>

              {pswderror && <div className="login_err_msg">{pswderror}</div>}
              <div className="form-control">
                <input
                  className="login-input"
                  autoComplete="current-password"
                  value={password}
                  type={show ? "text" : "password"}
                  placeholder="Password"
                  onChange={(e) => setPassword(e.target.value)}
                />
                <i className="fa fa-lock login_lock_icon"></i>
                <i className="fa_eye_icon" onClick={togglePassword}>
                  {show ? <IoEyeOffOutline /> : <FaRegEye />}
                </i>
              </div>

              {/* <div className="captcha">
                <ReCaptcha
                  siteKey="6LfdMIUpAAAAAFboyQAwnlX8ikyxl1eXy8YhERhN"
                  callback={handleToken}
                />
              </div> */}

              <button
                disabled={!submitEnabled}
                type="submit"
                className={`${
                  submitEnabled
                    ? "login-submit enabled"
                    : "login-submit disabled"
                }`}
              >
                Login
              </button>
            </form>
            {
              <Link to="/password-reset" className="forgot">
                Forgot password?
              </Link>
            }
          </div>
        </section>
      </div>

      {showModal && (
        <div className="modal-overlay">
          <div className="modal-content">
            <h2>Password Incorrect</h2>
            {/* <p className="login_modal_err">
              Kindly log in using the secret code as we have already sent it to your email address.
            </p> */}
            <p className="login_modal_err">
              Please log in using your old password, or select the ‘Forgot
              Password’ option to reset it.
            </p>
            <button onClick={() => setShowModal(false)}>Close</button>
          </div>
        </div>
      )}
    </div>
  );
};

export default Login;
